var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09229 0.821777C3.24229 0.821777 0.0922852 3.97178 0.0922852 7.82178C0.0922852 11.6718 3.24229 14.8218 7.09229 14.8218C10.9423 14.8218 14.0923 11.6718 14.0923 7.82178C14.0923 3.97178 10.9423 0.821777 7.09229 0.821777ZM5.69229 11.3218L2.19229 7.82178L3.17929 6.83478L5.69229 9.34078L11.0053 4.02778L11.9923 5.02178L5.69229 11.3218Z",
    fill: "#12A52A",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.e09ef9ccf8813136dd3141de55b8e562.svg";
export { ForwardRef as ReactComponent };